/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Order_Lot_Debt_BadgeInputs */

const vi_order_lot_debt_badge = /** @type {(inputs: Order_Lot_Debt_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nợ ${i?.count} loại`)
};

/**

* @param {Order_Lot_Debt_BadgeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_lot_debt_badge = /** @type {((inputs: Order_Lot_Debt_BadgeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Lot_Debt_BadgeInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_lot_debt_badge(inputs)
});